/**
 * Generates <number> interpolated colors from available list of colors
 *
 * @param number number
 * @param number[][] rgbaColors // [r,g,b,a][]
 */
/* eslint-disable */
export function interpolateColors(number: number, rgbaColors: number[][]): number[][] {
  if (1 === number) {
    return [rgbaColors[0]];
  }

  return Array.from(Array(number).keys()).map(i => {
    const valuePosition = i / (number - 1);
    const absoluteColorPosition = (rgbaColors.length - 1) * valuePosition;
    const prevColorIndex = Math.floor(absoluteColorPosition);
    const nextColorIndex = Math.ceil(absoluteColorPosition);
    const positionBetweenColors =
      nextColorIndex === absoluteColorPosition ? 1 : absoluteColorPosition % (prevColorIndex || 1);

    return Array.from(rgbaColors[prevColorIndex].keys()).map(j => {
      return Math.floor(
        (1 - positionBetweenColors) * rgbaColors[prevColorIndex][j] +
          positionBetweenColors * rgbaColors[nextColorIndex][j]
      );
    });
  });
}
